package diana.soleil.design.iraniancanadienbazzar.core.model

/**
 * A comment on a community post (`posts/{postId}/comments/{id}` — see `docs/DATA_MODEL.md`). Reading is
 * public; posting needs a real (non-anonymous) account. The parent post's `commentCount` is recomputed
 * server-side (a Cloud Function) since rules lock that field against client writes.
 */
data class Comment(
    val id: String,
    val authorUid: String,
    val authorName: String,
    val text: String,
    /**
     * "Ask the Mahaleh": a business this comment recommends as its answer (id + denormalized name so
     * the feed renders without extra reads). Null for plain comments. Tapping opens the business.
     */
    val recommendedBusinessId: String? = null,
    val recommendedBusinessName: String? = null,
    val createdAtMillis: Long? = null,
    /** Resolved against the signed-in uid by the repository (for "your comment" affordances). */
    val isMine: Boolean = false,
)
